import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, scale, gradient, verticalOffset }) {
  const randomGradientId1 = `_${useRandomId()}`

  const transformOrigin = '7.265 2.2849'
  return (
    <g transform={`scale(${scaleX},1) translate(0,${verticalOffset})`}>
      <g transform={`scale(${scale},${scale})`} transform-origin={transformOrigin}>
        <path
          d="M7.26001 4.02991C10.06 4.02991 12.63 3.26992 14.53 0.539917H0C1.89 3.26992 4.46001 4.02991 7.26001 4.02991Z"
          fill={`url(#${randomGradientId1})`}
        />
        <defs>
          <linearGradient
            id={randomGradientId1}
            x1="7.25831"
            y1="0.400017"
            x2="7.25831"
            y2="3.60881"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor={gradient[1]} stopOpacity="0" />
            <stop offset="0.8488" stopColor={gradient[0]} />
          </linearGradient>
        </defs>
      </g>
    </g>
  )
}
